import {ossUpload} from '@/api/system/upload.js'

export default class UploadFileToVOD {
  constructor(files, json) {
    if (!Array.isArray(files)) {
      throw new Error('Class UploadFileToOSS parameter must be an array');
    }
    console.log('files, json', files, json)
    this.data = [];
    this.fn = json.success;
    this.complete = json.finally;
    this.vProgress = json.vProgress;
    this.fileId = json.fileId;
    this.files = files;
    this.fileLen = this.files.length - 1;
    this.curIndex = 0;
    // notification.info({ message: '上传中' })
    this.upload();
  }

  upload() {
    ossUpload(this.files[this.curIndex]).then(res => {
      console.log(res);
      if (this.curIndex == this.fileLen) { // 当文件传完时，停止调用
        if(res.code == 20001) {
          this.data.push(res.data);
          // this.upload();
        }
        if (this.fn) this.fn(this.data);
        // this.complete(this.data);
      } else if(this.curIndex < this.fileLen){
        if(res.code == 20001) {
          this.data.push(res.data);
          if (this.fn) this.fn(this.data);
          this.upload();
        }
      } else {

      }
    })
  }
}